<template>
  <div class="solution">
    <div class="banner">
      <div class="title">连锁经营行业解决方案</div>
      <div class="desc">
        <section>搭建以内容中台为核心的全链路内容营销体系，助力连锁经营品牌实现全域增长</section>
      </div>
      <router-link target="_blank"  to='/contact'><div class="button">立即体验<i class="el-icon-right"></i></div></router-link> 
    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>新消费时代连锁经营企业品牌打造与内容营销更加注重设计美感与用户体验，传统设计</section>
            <section>服务审美老旧，无法满足颜值经济下的品牌升级需求；总部设计师在内容创作的过程中</section>
            <section>需要大量的版权素材，成本高且容易遇到版权风险</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">创意热店：</span>10年连锁经营及消费品牌创意设计服务经验，8大创意服务类型以及150+创</section>
            <section>意服务形式，为品牌提供多元优质的内容创意供给和数字化交付</section>
            <section><span>版权素材：</span>爱设计新型在线设计引擎， 0门槛在线作图，赋予企业全员内容生产能力</section>
            <section><span>AI设计：</span>亿级版权素材库，涵盖图片、视频、插画、psd、eps 等格式，为设计师提</section>
            <section>供创意灵感来源，商用场景全覆盖，规避版权风险</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/chain/1.png">
      </div>
      <div class="row drak">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/chain/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>场景触点多且业务增速快，痛点集中在数据与营销两方面，疫情对连锁经营行业持续造</section>
            <section>成冲击，获客难，获客贵，赛道竞争激烈，私域成为品牌营销必选项，但私域环境下大</section>
            <section>量的内容产能需求与千人千面的分发效率无法得到满足</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">在线设计：</span>爱设计新型在线设计引擎， 0门槛在线作图，赋予企业全员内容生产能力</section>
            <section><span>AI设计：</span>根据连锁经营主流营销场景，实现AI批量图片生产及尺寸延展，高效释放内容</section>
            <section>生产力</section>
            <section><span>私域内容分发：</span>通过 ConTech 创意云内容分发协作能力，智能解析 psd 文件，全员可</section>
            <section>根据自身需求修改本地化、个性化的内容，并一键分发至私域场景</section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>全域营销内容产能巨大，传统素材内容存储方式，杂乱无序，查找复用效率低下，且随</section>
            <section>人员流动丢失风险大，品牌规范性难以把控</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">品牌规范管理：</span>预设品牌vi规则，包含字体、icon、色值色号等，实现在线管理</section>
            <section><span>权限管理：</span>4级角色权限设置，管理内容的生产，协作，存储，分发及数据权限，保证</section>
            <section>分发内容的品牌合规性</section>
            <section><span>审批管理：</span>标准化的内容分发审批流程，double-check 机制确保内容和品牌的合规</section>
            <section><span>云端储存：</span>通过内容中台的形式在线存储，集中管理</section>
            <section><span>分类管理：</span>通过内容标签及分类的形式高效管理海量创意资源，方便查找及复用</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/chain/3.png">
      </div>
        <div class="row drak">
        <img class="img" :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_9.png`">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>私域内容分发效果无法追溯，营销链路出现断层</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">可视化数据看板：</span>内容中心超过 100+的数据分析指标，让企业的内容营销数据效果一</section>
            <section>目了然</section>
            <section><span>数据监测回流：</span>端到端的数据监测能力，为企业提供实时的营销数据反馈，反哺内容的</section>
            <section>迭代优化，形成营销闭环</section>
          </div>
        </div>
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'chain',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.solution{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/solution/chain/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 54px;
      }
     
    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
      .drak{
        background: #F7F7F9;
      }
      .row{
          padding-top: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            
              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;
            .marginTop16{
              margin-top: 16px;
            }
            .marginTop{
              margin-top: 0;
            }
            span{
              display: inline-block;
              color: #3B3946;
              font-weight: 600;
              margin-top: 16px;
            }
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 32px;
                position: relative;
                padding-left: 16px;
                &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(255, 167, 126, 0) 0%, #FF6E48 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                }
            }
            .purple{
              &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(90, 45, 245, 0) 0%, #5A2DF5 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                }
            }
          }
        }
        .img{
          width: 595px;
        }
        
      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            color: #FFFFFF;
            margin-left: 8px;
          }
        }
      }
}
</style>